(function goodDeedsRewards() {
  'use strict';

  var root = document.getElementById('GoodDeedsRewards');
  if (!root) return;

  var dialog = root.querySelector('.gd-rewards__dialog');
  var wheel = root.querySelector('.gd-rewards__wheel');
  var spinButton = root.querySelector('[data-gd-rewards-spin]');
  var result = root.querySelector('[data-gd-rewards-result]');
  var resultTitle = root.querySelector('[data-gd-rewards-result-title]');
  var codeOutput = root.querySelector('[data-gd-rewards-code]');
  var copyButton = root.querySelector('[data-gd-rewards-copy]');
  var copyLabel = root.querySelector('[data-gd-rewards-copy-label]');
  var applyLink = root.querySelector('[data-gd-rewards-apply]');
  var minimumOutput = root.querySelector('[data-gd-rewards-minimum]');
  var errorOutput = root.querySelector('[data-gd-rewards-error]');
  var startedKey = 'good-deeds-rewards-started-v1';
  var dismissedKey = 'good-deeds-rewards-dismissed-v1';
  var wonKey = 'good-deeds-rewards-prize-v1';
  var seenKey = 'good-deeds-rewards-seen-v2';
  var engagedKey = 'good-deeds-rewards-engaged-v1';
  var sessionKey = 'good-deeds-rewards-session-v1';
  var delay = Math.max(1, Number(root.dataset.delaySeconds || 20)) * 1000;
  var secureEndpoint = (root.dataset.secureEndpoint || '').trim();
  var sessionStore = resolveStorage('sessionStorage');
  var localStore = resolveStorage('localStorage');
  var previousFocus;
  var spinning = false;
  var timerReady = false;
  var requireEngagement = root.dataset.requireEngagement === 'true';
  var engaged = !requireEngagement || root.dataset.pageType === 'product' || Boolean(readStorage(localStore, engagedKey));
  var segmentAngle = 360 / 11;

  var segments = [
    { percentage: null, type: 'shipping', key: 'shipping', minimum: rewardMinimum('minShipping'), angle: segmentAngle * 0.5 },
    { percentage: 5, type: 'percentage', key: 'five', minimum: rewardMinimum('minFive'), angle: segmentAngle * 1.5 },
    { percentage: 10, type: 'percentage', key: 'ten', minimum: rewardMinimum('minTen'), angle: segmentAngle * 2.5 },
    { percentage: 5, type: 'percentage', key: 'five', minimum: rewardMinimum('minFive'), angle: segmentAngle * 3.5 },
    { percentage: 15, type: 'percentage', key: 'fifteen', minimum: rewardMinimum('minFifteen'), angle: segmentAngle * 4.5 },
    { percentage: 5, type: 'percentage', key: 'five', minimum: rewardMinimum('minFive'), angle: segmentAngle * 5.5 },
    { percentage: 10, type: 'percentage', key: 'ten', minimum: rewardMinimum('minTen'), angle: segmentAngle * 6.5 },
    { percentage: 20, type: 'percentage', key: 'twenty', minimum: rewardMinimum('minTwenty'), angle: segmentAngle * 7.5 },
    { percentage: 5, type: 'percentage', key: 'five', minimum: rewardMinimum('minFive'), angle: segmentAngle * 8.5 },
    { percentage: 15, type: 'percentage', key: 'fifteen', minimum: rewardMinimum('minFifteen'), angle: segmentAngle * 9.5 },
    { percentage: 10, type: 'percentage', key: 'ten', minimum: rewardMinimum('minTen'), angle: segmentAngle * 10.5 }
  ];
  var fallbackCodes = decodeFallbackCodes();
  var fallbackPrizes = segments.map(function (segment) {
    return Object.assign({}, segment, { code: fallbackCodes[segment.key] || '' });
  }).filter(function (prize) {
    return Boolean(prize.code);
  });

  if (!secureEndpoint && fallbackPrizes.length === 0) return;

  function rewardMinimum(key) {
    return Math.max(0, Number(root.dataset[key]) || 0);
  }

  function decodeFallbackCodes() {
    var payload = root.querySelector('[data-gd-reward-payload]');
    if (!payload || typeof window.atob !== 'function') return {};
    try {
      var encoded = JSON.parse(payload.textContent || '{}');
      return Object.keys(encoded).reduce(function (codes, key) {
        codes[key] = encoded[key] ? window.atob(window.atob(encoded[key])) : '';
        return codes;
      }, {});
    } catch (error) {
      return {};
    }
  }

  function formatRewardMoney(amount) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD',
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + Number(amount).toFixed(2);
    }
  }

  function resolveStorage(name) {
    try {
      return window[name];
    } catch (error) {
      return null;
    }
  }

  function readStorage(storage, key) {
    if (!storage) return null;
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(storage, key, value) {
    if (!storage) return;
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Shopping still works when a customer blocks browser storage.
    }
  }

  function rewardSessionId() {
    var current = readStorage(localStore, sessionKey);
    if (current) return current;
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      current = window.crypto.randomUUID();
    } else {
      current = 'gd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }
    writeStorage(localStore, sessionKey, current);
    return current;
  }

  function matchingSegments(type, percentageValue) {
    return segments.filter(function (segment) {
      if (type === 'shipping') return segment.type === 'shipping';
      return segment.type === 'percentage' && segment.percentage === percentageValue;
    });
  }

  function normalizeSecurePrize(payload) {
    var data = payload && (payload.reward || payload.prize || payload);
    if (!data || !data.code) throw new Error('Secure reward response is missing a code');
    var type = data.type === 'shipping' || data.rewardType === 'shipping' ? 'shipping' : 'percentage';
    var percentageValue = type === 'shipping' ? null : Number(data.percentage || data.discountPercentage);
    var candidates = matchingSegments(type, percentageValue);
    if (!candidates.length) throw new Error('Secure reward response has an unsupported prize');
    var segment = candidates[Math.floor(Math.random() * candidates.length)];
    var minimum = Number(data.minimumPurchase);
    return Object.assign({}, segment, {
      code: String(data.code).trim(),
      minimum: Number.isFinite(minimum) && minimum >= 0 ? minimum : segment.minimum
    });
  }

  function requestPrize() {
    if (!secureEndpoint) {
      return Promise.resolve(fallbackPrizes[Math.floor(Math.random() * fallbackPrizes.length)]);
    }
    if (typeof window.fetch !== 'function') return Promise.reject(new Error('Secure rewards require fetch support'));
    return window.fetch(secureEndpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        rewardSession: rewardSessionId(),
        cartTotalCents: Number(root.dataset.cartTotalCents || 0),
        currency: root.dataset.currency || 'USD',
        pageType: root.dataset.pageType || ''
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Secure reward request failed');
      return response.json();
    }).then(normalizeSecurePrize);
  }

  function revealPrize(prize) {
    resultTitle.textContent = prize.type === 'shipping' ? 'You got free shipping.' : 'You got ' + prize.percentage + '% off.';
    codeOutput.textContent = prize.code;
    copyButton.hidden = false;
    applyLink.hidden = false;
    applyLink.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(root.dataset.cartUrl);
    if (minimumOutput) {
      minimumOutput.hidden = !(prize.minimum > 0);
      if (prize.minimum > 0) {
        var remaining = Math.max(0, prize.minimum - Number(root.dataset.cartTotalCents || 0) / 100);
        minimumOutput.textContent = 'Minimum purchase: ' + formatRewardMoney(prize.minimum) +
          (remaining > 0 ? '. Add ' + formatRewardMoney(remaining) + ' more to qualify.' : '. Your current cart meets the minimum.');
      }
    }
    result.hidden = false;
    spinButton.hidden = true;
    spinButton.disabled = false;
    writeStorage(localStore, wonKey, JSON.stringify(Object.assign({}, prize, { awardedAt: new Date().toISOString() })));

    try {
      root.dispatchEvent(new CustomEvent('good-deeds:reward-awarded', {
        bubbles: true,
        detail: {
          discountPercentage: prize.percentage,
          rewardType: prize.type,
          minimumPurchase: prize.minimum
        }
      }));
    } catch (error) {
      // Optional analytics must never interrupt the Shopify purchase flow.
    }
  }

  function close() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gd-rewards-open');
    writeStorage(sessionStore, dismissedKey, 'yes');
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  function open() {
    if (readStorage(localStore, seenKey) || readStorage(sessionStore, seenKey)) return;
    writeStorage(localStore, seenKey, 'yes');
    writeStorage(sessionStore, seenKey, 'yes');
    previousFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gd-rewards-open');
    dialog.focus();
  }

  function maybeOpen() {
    if (!timerReady || !engaged || document.visibilityState === 'hidden') return;
    open();
  }

  function markEngaged() {
    if (engaged) return;
    engaged = true;
    writeStorage(localStore, engagedKey, 'yes');
    maybeOpen();
  }

  function spin() {
    if (spinning) return;
    spinning = true;
    spinButton.disabled = true;
    spinButton.textContent = secureEndpoint ? 'Securing your reward…' : 'Finding your good thing…';
    if (errorOutput) errorOutput.hidden = true;

    requestPrize().then(function (prize) {
      if (!prize || !prize.code) throw new Error('Reward is unavailable');
      var rotation = 5 * 360 + (360 - prize.angle);
      wheel.style.setProperty('--gd-wheel-rotation', rotation + 'deg');
      wheel.classList.add('is-spinning');
      window.setTimeout(function () {
        revealPrize(prize);
        spinning = false;
      }, 4400);
    }).catch(function () {
      spinning = false;
      spinButton.disabled = false;
      spinButton.textContent = 'Try the wheel again';
      if (errorOutput) errorOutput.hidden = false;
    });
  }

  root.querySelectorAll('[data-gd-rewards-close]').forEach(function (element) {
    element.addEventListener('click', close);
  });
  spinButton.addEventListener('click', spin);
  copyButton.addEventListener('click', function () {
    if (!navigator.clipboard || !codeOutput.textContent) return;
    navigator.clipboard.writeText(codeOutput.textContent).then(function () {
      copyLabel.textContent = 'Copied';
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) close();
  });

  if (
    readStorage(localStore, seenKey) ||
    readStorage(sessionStore, seenKey) ||
    readStorage(localStore, wonKey) ||
    readStorage(sessionStore, dismissedKey)
  ) return;

  document.addEventListener('click', function (event) {
    var productLink = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (productLink) markEngaged();
  }, { passive: true });
  window.addEventListener('scroll', function () {
    if (window.scrollY >= Math.min(480, Math.max(220, window.innerHeight * 0.45))) markEngaged();
  }, { passive: true });
  document.addEventListener('visibilitychange', maybeOpen);

  var startedAt = Number(readStorage(sessionStore, startedKey));
  if (!startedAt || !Number.isFinite(startedAt)) {
    startedAt = Date.now();
    writeStorage(sessionStore, startedKey, String(startedAt));
  }
  window.setTimeout(function () {
    timerReady = true;
    maybeOpen();
  }, Math.max(0, delay - (Date.now() - startedAt)));
})();
